/*
  SAVRA product form — progressive enhancement over native /cart/add.
  On fetch failure or missing cart drawer, falls back to the form's real
  action (return_to redirects to /cart). Gallery thumbnails swap the main
  image; no framework, no fabricated state.
*/
(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.Shopify || !window.Shopify.routes) return;
      e.preventDefault();

      var btn = form.querySelector('[data-add-to-bag]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add to cart failed');
          return r.json();
        })
        .then(function () {
          if (window.savraCartDrawer) {
            return window.savraCartDrawer.refresh().then(function () {
              window.savraCartDrawer.open();
            });
          }
          window.location = form.getAttribute('action');
        })
        .catch(function () {
          form.submit();
        })
        .then(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
        });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    if (!main) return;
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) {
          // srcset/sizes take priority over src in the browser's image
          // selection algorithm, so they must be cleared before swapping
          // src or the previous responsive image keeps winning.
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = full;
        }
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  });

  // Click-to-zoom lightbox: a real prev/next gallery over the product's
  // full image set, sourced from the thumbnail buttons already in the DOM
  // (single source of truth for order/urls). Opens with a fade+scale
  // transition (class-toggled, not just [hidden]) and honors
  // prefers-reduced-motion via the CSS transition itself being skipped.
  var lightbox = document.querySelector('[data-lightbox]');
  if (lightbox) {
    var lightboxImg = lightbox.querySelector('[data-lightbox-img]');
    var counterEl = lightbox.querySelector('[data-lightbox-counter]');
    var prevBtn = lightbox.querySelector('[data-lightbox-prev]');
    var nextBtn = lightbox.querySelector('[data-lightbox-next]');
    var lastFocused = null;
    var currentIndex = 0;

    var slides = Array.prototype.map.call(
      document.querySelectorAll('[data-gallery-thumb], [data-gallery-zoom]'),
      function (el) { return { full: el.getAttribute('data-full') || (el.querySelector('img') && el.querySelector('img').getAttribute('src')), alt: (el.querySelector('img') && el.querySelector('img').getAttribute('alt')) || '' }; }
    );
    // De-duplicate: the main zoom trigger and the first thumbnail point at
    // the same image.
    var seen = {};
    slides = slides.filter(function (s) {
      if (!s.full || seen[s.full]) return false;
      seen[s.full] = true;
      return true;
    });

    function render() {
      var slide = slides[currentIndex];
      if (!slide) return;
      lightboxImg.src = slide.full;
      lightboxImg.alt = slide.alt;
      if (counterEl) counterEl.textContent = (currentIndex + 1) + ' / ' + slides.length;
    }

    function openLightbox(index) {
      lastFocused = document.activeElement;
      currentIndex = index || 0;
      render();
      lightbox.hidden = false;
      // Force layout so the browser registers the pre-transition state
      // before the class flip animates it (fade + scale in).
      void lightbox.offsetWidth;
      lightbox.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lightbox.querySelector('[data-lightbox-close]').focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
      window.setTimeout(function () {
        if (!lightbox.classList.contains('is-open')) {
          lightbox.hidden = true;
          lightboxImg.src = '';
        }
      }, 250);
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      render();
    }
    function showNext() {
      currentIndex = (currentIndex + 1) % slides.length;
      render();
    }

    document.querySelectorAll('[data-gallery-zoom]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var full = trigger.getAttribute('data-full') || (trigger.querySelector('img') && trigger.querySelector('img').getAttribute('src'));
        var idx = slides.findIndex(function (s) { return s.full === full; });
        openLightbox(idx > -1 ? idx : 0);
      });
    });

    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', closeLightbox);
    });
    if (prevBtn) prevBtn.addEventListener('click', showPrev);
    if (nextBtn) nextBtn.addEventListener('click', showNext);

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') showPrev();
      if (e.key === 'ArrowRight') showNext();
    });
  }

  // Reviews modal: "View more reviews" opens the full list in a dialog.
  var reviewsModal = document.querySelector('[data-reviews-modal]');
  if (reviewsModal) {
    var reviewsLastFocused = null;

    function openReviewsModal() {
      reviewsLastFocused = document.activeElement;
      reviewsModal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = reviewsModal.querySelector('[data-reviews-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeReviewsModal() {
      reviewsModal.hidden = true;
      document.body.style.overflow = '';
      if (reviewsLastFocused) reviewsLastFocused.focus();
    }

    document.querySelectorAll('[data-reviews-open]').forEach(function (btn) {
      btn.addEventListener('click', openReviewsModal);
    });
    reviewsModal.querySelectorAll('[data-reviews-close]').forEach(function (el) {
      el.addEventListener('click', closeReviewsModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !reviewsModal.hidden) closeReviewsModal();
    });
  }
})();
